module.exports = __webpack_public_path__ + "img/4.b0d5bde7.jpg";